import { useEffect, useRef } from 'react'
import { LuX } from 'react-icons/lu'

import styles from './GeoFenceCancelDialog.module.css'

type GeoFenceCancelDialogProps = {
  open: boolean
  onDiscard: () => void
  onCancel: () => void
}

export const GeoFenceCancelDialog = ({ open, onDiscard, onCancel }: GeoFenceCancelDialogProps) => {
  const cancelDialog = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (open) {
      cancelDialog.current?.showModal()
    } else {
      cancelDialog.current?.close()
    }
  }, [open, cancelDialog])

  return (
    <dialog className={styles.cancelDialog} ref={cancelDialog}>
      <header>
        <h3>Exit without saving</h3>
        <button
          type="button"
          name="close"
          aria-label="close"
          onClick={onCancel}
          className={styles.closeButton}
        >
          <LuX size={24} strokeWidth={1.5} />
        </button>
      </header>
      <section>Are you sure you want to exit without saving</section>
      <footer>
        <div className={styles.footerContainer}>
          <button
            type="button"
            name="cancel"
            aria-label="cancel"
            onClick={onCancel}
            className={styles.cancelButton}
          >
            Continue
          </button>
          <button
            type="button"
            name="discard"
            aria-label="discard"
            onClick={onDiscard}
            className={styles.discardButton}
          >
            Discard
          </button>
        </div>
      </footer>
    </dialog>
  )
}
